// extracted by mini-css-extract-plugin
module.exports = {"loader":"PortalsUploadListForm_loader__1Pt1-"};